import { render } from "./ui-tabs.vue?vue&type=template&id=65eb3371&scoped=true&ts=true"
import script from "./ui-tabs.vue?vue&type=script&lang=ts"
export * from "./ui-tabs.vue?vue&type=script&lang=ts"

import "./ui-tabs.vue?vue&type=style&index=0&id=65eb3371&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65eb3371"]])

export default __exports__